import { ConfigServiceProvider } from '../../core/services/config-service/config-service';
import { DictionaryEntry } from '../../../shared/interfaces/dictionary-entry.interface';
import { FormField } from '../../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-field.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageServiceProvider } from '../../core/services/storage-service/storage-service';

@Injectable()
export class ProjectService {
  private readonly createProjectFromDefinition = 'createProjectFormDefinition';
  private readonly createProject = 'createProject';

  private readonly modifyProjectFromDefinition = 'modifyProjectFormDefinition';
  private readonly modifyProject = 'modifyProject';

  constructor(private configService: ConfigServiceProvider, private http: HttpClient, private storageService: StorageServiceProvider) {}

  load() {
    this.getProcessForm(this.createProjectFromDefinition);
    this.getProcessForm(this.modifyProjectFromDefinition);
  }

  private getProcessForm(formKey: string): void {
    this.http.get<FormField[]>(this.configService.getEngineUrl(formKey)).subscribe(
      (response) => this.storageService.setObject(formKey, response),
      (error) => console.error(error),
    );
  }

  getCreateFormDefinition(): Promise<FormField[]> {
    return this.storageService.getObject(this.createProjectFromDefinition);
  }

  getModifyFormDefinition(): Promise<FormField[]> {
    return this.storageService.getObject(this.modifyProjectFromDefinition);
  }

  saveProject(project: SaveProject): Observable<any> {
    return this.http.post(this.configService.getEngineUrl(this.createProject), project);
  }

  editProject(project: ModifyProject): Observable<any> {
    return this.http.post(this.configService.getEngineUrl(this.modifyProject), project);
  }
}

export interface SaveProject {
  clients: Array<any>;
  description: string;
  endDate: string;
  investor: string;
  locality: string;
  name: string;
  product: Array<{
    assortment: string;
    unit: DictionaryEntry;
    volume: number;
  }>;
  projectType: DictionaryEntry;
  startDate: string;
  status: DictionaryEntry;
}

export interface ModifyProject extends SaveProject {
  project: any;
}



// WEBPACK FOOTER //
// ./src/modules/projects/services/project.service.ts